import type {
  AIDraftFormPrefillValue,
  CreatePlatformReplyRequest,
} from "@/hooks/api"

interface ReplyContextAnchor {
  part_id: number
  sequence: number
}

interface BuildPlatformReplyRequestOptions {
  content: string
  attachmentId?: string
  idempotencyKey: string
  appliedDraftId: number | null
  observedContextAnchor: ReplyContextAnchor | null
  /** Null when the draft proposed no form or the operator removed it. */
  formPrefilledValues?: Record<string, AIDraftFormPrefillValue> | null
}

export const buildPlatformReplyRequest = ({
  content,
  attachmentId,
  idempotencyKey,
  appliedDraftId,
  observedContextAnchor,
  formPrefilledValues = null,
}: BuildPlatformReplyRequestOptions): CreatePlatformReplyRequest => ({
  content,
  ...(attachmentId ? { attachment_id: attachmentId } : {}),
  idempotency_key: idempotencyKey,
  ...(appliedDraftId != null ? { applied_draft_id: appliedDraftId } : {}),
  ...(appliedDraftId != null && observedContextAnchor != null
    ? { observed_context_anchor: observedContextAnchor }
    : {}),
  ...(appliedDraftId != null && formPrefilledValues != null
    ? {
        form: {
          prefilled_values: formPrefilledValues,
        },
      }
    : {}),
})
